import { render, staticRenderFns } from "./RephonicSearch.vue?vue&type=template&id=4f5f68c6"
import script from "./RephonicSearch.vue?vue&type=script&lang=js"
export * from "./RephonicSearch.vue?vue&type=script&lang=js"
import style0 from "./RephonicSearch.vue?vue&type=style&index=0&id=4f5f68c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports